import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  protected readonly router: Router;
  protected readonly keycloak: KeycloakService;

  constructor() {
    const router = inject(Router);
    const keycloak = inject(KeycloakService);

    super(router, keycloak);

    this.router = router;
    this.keycloak = keycloak;
  }

  public async isAccessAllowed(route: ActivatedRouteSnapshot) {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      await this.keycloak.login();
    }
    // Get the roles required from the route.
    const requiredRoles = route.data.roles;
    // Allow the user to to proceed if no additional roles are required to access the route.
    if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
      return true;
    }
    // Allow the user to proceed if all the required roles are present.
    const canActivate = requiredRoles.every((role) =>
      this.roles.includes(role)
    );

    if (!canActivate) {
      this.router.navigate(['/forbidden']);
      return false;
    }
    return true;
  }
}
